import React, {
    useState, useEffect 
} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import COLORS from '@mlb/react-patterns/style/universal.color';
import { media } from '@mlb/react-patterns/style/helpers/media.ts';

import {
    FILTER_BREAKPOINT,
    FILTER_ANIMATION_SECONDS,
} from 'bdvp-advanced-search';

import Content from './Content';
import Filter from './Filter';

export const Wrapper = styled.div`
    flex: 1;
    display: flex;
    flex-direction: row;
    margin-left: ${({ theme }) => `-${theme.filter.width}`};

    ${media[`${FILTER_BREAKPOINT}min`]`
        transition: margin-left ${FILTER_ANIMATION_SECONDS}s ease-in-out;
        margin-left: ${({ isFilterActive, theme }) => isFilterActive ? `0px` : `-${theme.filter.width}`};
    `}
`;

const Template = ({
    content,
    filter,
    modals,
    subnav,
    isFilterActive,
}) => {

    return (
        <>
            {subnav}
            <Wrapper isFilterActive={isFilterActive}>
                <Filter isFilterActive={isFilterActive}>
                    {filter}
                </Filter>
                <Content>
                    {content}
                </Content>
            </Wrapper>
            {modals}
        </>
    );

};

Template.propTypes = {
    content: PropTypes.element.isRequired,
    filter: PropTypes.element.isRequired,
    modals: PropTypes.element,
    subnav: PropTypes.element,
    isFilterActive: PropTypes.bool,
};

Template.defaultProps = {
    isFilterActive: false,
};

export default Template;
